import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OrderByPrecipitationPipe } from "./order-by-precipitation.pipe";

@NgModule({
  declarations: [OrderByPrecipitationPipe],
  imports: [CommonModule],
  exports: [OrderByPrecipitationPipe],
})
export class OrderByPrecipitationModule {}
